import axios from 'axios';

const client = axios.create();

client.defaults.baseURL = '/heclore/';

client.apiKey_en = 'Q3dfND15JnxHeVlFKWcoMUI='; // base64

client.interceptors.request.use(
  (config) => {
    if (config.headers.Authorization) {
      return config;
    }
    try {
      const userString = localStorage.getItem('user');
      if (userString) {
        const user = JSON.parse(userString);
        if (user && user.token) {
          config.headers['Authorization'] = `Bearer ${user.token}`;
        }
      }
    } catch (e) {
      console.error('Could not get token from localStorage', e);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default client;

// const helpdeskClient = axios.create();
// helpdeskClient.defaults.baseURL = process.env.REACT_APP_HELPDESK_URL
//   ? process.env.REACT_APP_HELPDESK_URL + '/helpédesk/WebObjects/Helpdesk.woa/'
//   : '/helpdesk/WebObjects/Helpdesk.woa/';

// helpdeskClient.defaults.withCredentials = true;
// helpdeskClient.defaults.crossDomain = true;

// export { helpdeskClient };
